import React from 'react';
import SectionTitle from '../SectionTitle';

function ProjectsSection() {
    return (
        <div className="h-screen w-full lg:w-1/2 mt-4 justify-self-center">
            <SectionTitle title="Projetos" />
        </div>
    )
}

export default ProjectsSection;